/**
 * 与 APP / 微信交互的聚合接口
 *
 * 2026-10-14：PHP 接口下线，原 phpAxios 的 dd_* 签名与 `@/libs/axios` 的 ag_* 签名均不再使用，
 * 统一改为继承 javaAxios（baseUrl 取 env.apiUrl，鉴权走 rand + vsign + user_id + token）。
 *
 * 注意：javaAxios.get/post 内部会拼接 this.apiUrl，这里只传路径、不要再拼 apiUrl。
 */
import http from '@/libs/javaAxios'

export default class aguiApi extends http {
  /* 用户注册协议 / 单页（type：注册协议-agreement，绑卡协议-tied_card） */
  static async getAgreement(data) {
    return await this.post('/pages/info', data)
  }

  /* 根据推广码获取用户信息 */
  static async getInviteUser(data) {
    return await this.post('/invitation/code', data)
  }

  /* 获得微信公众号设置 */
  static async getWXConfig(data) {
    return await this.post('/wechat/jssdk', data)
  }

  /* 分享页配置信息 */
  static async getShareSet(data) {
    return await this.post('/system/share', data)
  }

  /**
   * APP 下载信息（叮当云）。
   *
   * 2026-10-22 改为指向叮当云自己的接口 `/download/app_info`。
   * 原来是照搬 mall 轨的 `/app/upload/info` —— 那是富迪布谷（agui-mall）的接口，
   * 在叮当云服务里既没有该路径，`/app/**` 又整体在登录拦截器内，未登录用户根本取不到地址。
   * 新接口只查 `system_app_upload` 里 app_code=2001 的最新启用版本，返回
   * `{app_url, app_name, curr_version, update_context, has_version}`。
   */
  static async getDownloadApp(data) {
    return await this.post('/download/app_info', data)
  }

  /* 用户注册-登录（验证码登录） */
  static async userSignUp(data) {
    return await this.post('/user/login', data)
  }

  /* 短信验证码 */
  static async getSms(data) {
    return await this.post('/send/smscode', data)
  }

  /* 获取商品详情 */
  static async getProDetail(data) {
    return await this.post('/product/detail', data)
  }
}
